import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { fetchUserStatsAndStatus } from '../services/analytics';

const DashboardPage: React.FC = () => {
  const [userStats, setUserStats] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    async function loadStats() {
      setLoading(true);
      const userSummary = await fetchUserStatsAndStatus();
      setUserStats({
        total: userSummary.total,
        active: userSummary.active,
        inactive: userSummary.inactive,
      });
      setLoading(false);
    }
    loadStats();
  }, []);

  if (loading) {
    return <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh"><Typography>Loading...</Typography></Box>;
  }

  return (
    <Box maxWidth={900} mx="auto" p={2}>
      <Typography variant="h4" fontWeight={700} color="primary" mb={3}>
        Admin Dashboard
      </Typography>
      <Box display="flex" flexWrap="wrap" gap={3} mb={4}>
        <Paper elevation={4} sx={{ p: 4, flex: '2 1 340px', minWidth: 340, display: 'flex', flexDirection: 'column', alignItems: 'center', background: 'linear-gradient(90deg, #1976d2 0%, #42a5f5 100%)', color: 'white' }}>
          <Typography variant="h6" fontWeight={600} mb={1} sx={{ opacity: 0.9 }}>Total Users</Typography>
          <Typography variant="h1" fontWeight={900} mb={1} sx={{ fontSize: { xs: 48, md: 72 }, lineHeight: 1 }}>{userStats.total}</Typography>
          <Box display="flex" gap={2} mb={2}>
            <Typography variant="subtitle1" fontWeight={600} sx={{ color: 'white', opacity: 0.95 }}>Active: <b>{userStats.active}</b></Typography>
            <Typography variant="subtitle1" fontWeight={600} sx={{ color: 'white', opacity: 0.95 }}>Inactive: <b>{userStats.inactive}</b></Typography>
          </Box>
        </Paper>
      </Box>
      <Box display="flex" flexWrap="wrap" gap={3}>
        <Paper elevation={2} sx={{ p: 3, flex: '1 1 220px', minWidth: 220, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Typography variant="h6" fontWeight={600} mb={1}>Users</Typography>
          <Button variant="contained" color="primary" onClick={() => navigate('/analytics/users')}>Access User Analytics</Button>
        </Paper>
        <Paper elevation={2} sx={{ p: 3, flex: '1 1 220px', minWidth: 220, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Typography variant="h6" fontWeight={600} mb={1}>Hackathons</Typography>
          <Button variant="contained" color="primary" onClick={() => navigate('/analytics/hackathons')}>Access Hackathon Data</Button>
        </Paper>
        <Paper elevation={2} sx={{ p: 3, flex: '1 1 220px', minWidth: 220, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Typography variant="h6" fontWeight={600} mb={1}>Events</Typography>
          <Button variant="contained" color="primary" onClick={() => navigate('/analytics/events')}>Access Event Data</Button>
        </Paper>
        <Paper elevation={2} sx={{ p: 3, flex: '1 1 220px', minWidth: 220, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Typography variant="h6" fontWeight={600} mb={1}>Quizzes</Typography>
          <Button variant="contained" color="primary" onClick={() => navigate('/analytics/quizzes')}>Access Quiz Data</Button>
        </Paper>
        <Paper elevation={2} sx={{ p: 3, flex: '1 1 220px', minWidth: 220, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Typography variant="h6" fontWeight={600} mb={1}>Contacts</Typography>
          <Button variant="contained" color="primary" onClick={() => navigate('/analytics/contacts')}>Access Contact Data</Button>
        </Paper>
      </Box>
    </Box>
  );
};

export default DashboardPage; 